import React, { FC, ReactNode } from 'react';
import { NavBar as Nav, Footer } from '../Nav';
import { useStaticQuery, graphql } from 'gatsby';
import { siteMetaQuery } from '../../staticQueries';

interface LayoutWebProps {
  children: ReactNode;
}

const LayoutWeb: FC<LayoutWebProps> = ({ children }) => {
  const { title, slogan } = siteMetaQuery();

  return (
    <div>
      <Nav title={title} />
      <main>{children}</main>
      <Footer title={title} subtitle={slogan} />
    </div>
  );
};

export { LayoutWeb };
